import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment'; // Import environment


@Injectable({
  providedIn: 'root'
})
export class PlacesService {

  private apiUrl = 'https://places.geo.us-east-1.amazonaws.com/v2/autocomplete';
  private apiKey = environment.awsPlacesApiKey;
  private baseLocationCoordinates = [-95.3698, 29.7604]; // 1 Baylor Plz, Houston, TX 77030, United States
  private includedCournties = ["US"];

  constructor(private http: HttpClient) { }

  getAddressSuggestions(
    queryText: string
  ): Observable<any[]> {
    const placesApiUrl = `${this.apiUrl}?key=${this.apiKey}`;
    const requestBody = {
      "QueryText": queryText,
      "BiasPosition": this.baseLocationCoordinates,
      "AdditionalFeatures": ["Core"],
      "Filter": {
      "IncludeCountries": this.includedCournties
      }
    }
    return this.http.post<any>(placesApiUrl, requestBody).pipe(
      map(response => 
        response.ResultItems?.map((item: any) => item.Address?.Label) || []
      )
    );
  }

 
}
